import React from 'react';

const SolutionsSection = () => {
    const solutions = [
        {
            title: "Strategic road mapping",
            description: "Ferritico runs assessments and workshops to define AI adoption targets, data needs, priority processes, and implementation plans for R&D or production environments.",
        },
        {
            title: "Custom AI simulation modules",
            description: "Ferritico can adapt existing models or develop new ones from scratch using proprietary customer data, creating a digital twin for a unique alloy system or production environment.",
        },
        {
            title: "Deployment flexibility",
            description: "Solutions can integrate into existing operations through secure cloud delivery or on-premises APIs and can connect with FEM software or laboratory databases.",
        },
        {
            title: "Sustainable innovation",
            description: "Ferritico aligns technical improvements with sustainability goals by reducing resource-intensive physical trials while improving environmental performance.",
        }
    ];

    return (
        <section className="solutions-section" id="services">
            <div className="value-container">
                <div className="section-header">
                    <span className="section-label">Services</span>
                    <h2 className="section-title">AI Consulting and Custom Industry Solutions</h2>
                    <p className="section-subtitle">
                        Ferritico partners with customers beyond software alone.
                    </p>
                </div>

                <div className="solutions-grid">
                    {solutions.map((solution, index) => (
                        <div key={index} className="solution-card">
                            <div className="solution-content">
                                <h3 className="solution-title">{solution.title}</h3>
                                <p className="solution-description">{solution.description}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="solutions-cta">
                    <a href="#contact" className="btn-primary">
                        Contact Ferritico for a free consultation on virtual alloy design, process optimization, AI strategy, or custom modeling.
                    </a>
                </div>
            </div>
        </section>
    );
};

export default SolutionsSection;